module.exports = __webpack_public_path__ + "static/media/mech3.2b4de19c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mech3.jpg
// module id = 5820
// module chunks = 0